import React from 'react';
import * as d3 from '../../../libraries/d3';
import DateHelper from '../../DateHelper/DateHelper';

export default class AreaPaths extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.initState();
  };

  componentDidMount() {
    let clip = this.props.bounds()
      .append("defs").append("svg:clipPath")
      .attr("id", "clip")
      .append("svg:rect")
      .attr("width", this.props.dimensions().boundedWidth)
      .attr("height", this.props.dimensions().boundedHeight)
      .attr("x", 0)
      .attr("y", 0)
      .attr("class", 'svg-clipPath');

    let brush = d3.brushX()                
      .extent([[0, 0], [this.props.dimensions().boundedWidth, this.props.dimensions().boundedHeight] ]) 

    let areaChart = this.props.bounds()
      .append('g')
      .attr("clip-path", "url(#clip)")
      .attr("class", 'clip-paths');

    // Area generator
    let area = d3.area()
      .x( (d) =>{return this.props.xScale(this.props.xDateAccessor(d.data)); })
      .y0((d) => { return this.props.yScale(this.props.dataType === 'percent' ? parseFloat(d[0] * 100) : d[0]); })
      .y1((d) => { return this.props.yScale(this.props.dataType === 'percent' ? parseFloat(d[1] * 100) : d[1]); })

    areaChart
      .selectAll("data-paths")
      .data(this.state.stackedData)
      .enter()
      .append("path")
      .attr("class", function (d) { return "path-" + d.key.replace(/ /g, "_") })
      .style("fill",  (d) => { return this.state.colors(d.key); })
      .attr("d", area);

    areaChart
      .append("g")
      .attr("class", "brush")
      .call(brush);
  };

  componentDidUpdate(prevProps) {
    let yDetails = this.props.yAxisDetails;
    let tempState = this.initState();
    let xScale = d3.scaleTime().domain(d3.extent(this.props.data, (d) => DateHelper.parseDate(d[this.props.xAxisDetail.data_column_name], this.props.date_format))).nice().range([0, this.props.dimensions().boundedWidth]);
    let yScale = this.props.dataType == 'percent' ? d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]) : d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0]);
    let brush = d3.brushX()
      .extent([[0, 0], [this.props.dimensions().boundedWidth, this.props.dimensions().boundedHeight]]);
    
      let area = d3.area()
      .x((d) => { return xScale(this.props.xDateAccessor(d.data)); })
      .y0((d) => { return yScale(this.props.dataType === 'percent' ? parseFloat(d[0] * 100) : d[0]); })
      .y1((d) => { return yScale(this.props.dataType === 'percent' ? parseFloat(d[1] * 100) : d[1]); });

    let areaChart = d3.selectAll('.clip-paths');


    let t = d3.transition()
      .duration(750)
      .ease(d3.easeLinear);

    areaChart
      .data(tempState.stackedData)
      .enter(
        yDetails.forEach((detail) => {
          d3.selectAll(`.path-${detail.data_column_name.replace(/ /g, "_")}`)
            .transition(t)
            .attr("d", area)
        })
        
        // singlePath
        //   .transition(t)
        //   .attr("d", area)
      );

    areaChart.call(brush);
  };

  render() {
    return (
      null
    );
  };

  initState() {
    let colors = []
    let keys = []

    this.props.yAxisDetails.forEach((detail) => {
      keys.push(detail.data_column_name);
      colors.push(detail.color);
    });

    let stackedData = d3.stack()
      .keys(keys)
      (this.props.data)

    return{
      colors: d3.scaleOrdinal()
        .domain(keys)
        .range(colors),
      keys: keys,
      stackedData: stackedData,
    };
  };

};